import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import BaseSelector from './BaseSelector';
import Button from 'react-bootstrap/lib/Button';
import Popover from 'react-bootstrap/lib/Popover';
import Tooltip from 'react-bootstrap/lib/Tooltip'; 
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger';
import { allowsEmptyValue } from './emptyValue';
/**
 * SingleSelector widget
 */
class SingleSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {

    }
    this.myRef = React.createRef();
    /**
     * @private
     * @type {Array<string>}
     * Stores the search matched items for Shift Key operation.
     */
    this.searchMatched = [];
  }

  componentDidMount() {
    if (this.myRef.current) {
      const currentHeight = this.myRef.current.refs["column-list"].clientHeight;
      this.myRef.current.refs["column-list"].style.minHeight = currentHeight + 2 + "px";
      this.myRef.current.refs["column-list"].style.maxHeight = currentHeight + 2 + "px";
    }
  };

  render() {
    const availableValueStrings = this.props.variable.options && Array.isArray(this.props.variable.options) ? this.props.variable.options.map((value)=>{
      return value.value !== undefined ? value.value : value;
    }) : [];
    const selectedValues = [];
    const options = [];
    // convert selected value to string
    if (this.props.variable.value !== undefined && this.props.variable.value !== null) {
      this.props.variable.value = this.props.variable.value + "";
    }
    this.props.variable.options.some((option) => {
      // convert displayName, name, and value to string.
      option.displayName = option.displayName !== undefined && option.displayName !== null ? (option.displayName + "") : "";
      option.name = option.name !== undefined && option.name !== null ? (option.name + "") : "";
      option.value = option.value !== undefined && option.name !== null ? (option.value + "") : "";      
      const item = {
        "name": option.displayName || option.name, 
        "value": option.value || option.name, 
        "canRemove": option.canRemove === true
      }
      if (this.props.variable.value !== undefined && this.props.variable.value === option.value) {
        selectedValues.push(item);
      }
      options.push(item);
    });
    if (allowsEmptyValue(this.props.variable) && !this.props.variable.multivalued) {
      const emptyItem = {name: this.props.variable.optionsAltEmptyLabelName || this.props.getMessage("dataframe.(Select None)"), value: "", canRemove: false}
      if (options[0] && options[0].name !== emptyItem.name && options[0].value !== emptyItem.value) {
        options.unshift(emptyItem);
      }
      if (this.props.variable.value === null || this.props.variable.value === undefined || this.props.variable.value === "") {
        selectedValues[0] = emptyItem;
      }
    }
    // make sure to add the newly created options to the selected options
    if (this.props.variable.value !== undefined && selectedValues.length === 0) {
      const newOption = {value:this.props.variable.value, name: this.props.variable.value, displayName: this.props.variable.value, canRemove: true};
      selectedValues.push(newOption);
      if (!this.props.variable.options.map(val => {return val.value}).includes(this.props.variable.value)) {
        options.push(newOption);
      }
    }
    

    const _onItemSelect = (value, event, values/*, searchMatched*/) => {
      this.props.onSuggestionSelected(value.item.value);
      document.body.click(); //close the single select menu
    };

    let style = {"marginTop": "-27px"};
    let listStyle = {"marginBottom": "-1px"};
    if (this.props.variable.lovWidgetType === "list") {
      style = {};
      listStyle = {"marginBottom": "10px"}
    }

    const widget = (
      <div className="multi-select-list-wrapper" style={style}>
        <BaseSelector 
          ref={this.myRef} 
          label={this.props.variable.displayName || this.props.variable.name}
          autoSelect={false}
          selectedItems={selectedValues} 
          items={options}
          onDeleteCreatedOption={(items/*the latest available options that reflects manually added options*/, deletedItem)=>{
              this.props.variable.options = items;
              if (deletedItem && this.props.variable.value === deletedItem.value) {
                this.props.variable.value = "";
                this.setState({refresh: true});
              }
            }
          }
          listStyle={listStyle}
          getMessage={this.props.getMessage}
          allowCreate={true}
          lovWidgetType={this.props.variable.lovWidgetType}
          disabledItems={this.props.disabledItems || []}
          enableDragAndDrop={false}
          selectionType={"radio"}
          onItemSelect={_onItemSelect}/>
      </div>  
    );
    if (this.props.variable.lovWidgetType !== "list") {
      const tooltip = (
        <Popover className="multi-select-popover">
          {widget}
        </Popover>
      );
      const labels = selectedValues.map(option => {return option.name}).join(", ");
      const labelWrapper = selectedValues.length > 0 ? (
        <OverlayTrigger trigger={"hover"} overlay={<Tooltip>{labels}</Tooltip>} rootClose={true} placement={"top"}>
          <div className="label-wrapper"><div className="values-wrapper">{labels}</div><div className="caret"></div></div>
        </OverlayTrigger>
      ) : (
        <div className="label-wrapper"><div className="values-wrapper">{labels}</div><div className="caret"></div></div>
      )
      return (
        <OverlayTrigger trigger={"click"} overlay={tooltip} rootClose={true} placement={this.props.index > 5 ?  "top" : "bottom"}>
          <Button className="open-lov-window-button">
            {labelWrapper}
          </Button>
        </OverlayTrigger>
      );
    } else {
      return widget;
    }
  }
}
export default SingleSelector;
